module.exports = __webpack_public_path__ + "2290acd08dd4f2ddfe0329673543d352.svg";